export default function FacebookIcon() {
  return (
    <svg
      fill="none"
      height="14"
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.84377 4.8412H7.90337V3.57C7.90337 3.0926 8.22117 2.9806 8.44377 2.9806H9.81017V0.882L7.92577 0.875C5.83557 0.875 5.36097 2.4402 5.36097 3.4426V4.8412H4.15137V7.0028H5.36097V13.1236H7.90477V7.0042H9.62117L9.84377 4.8412Z"
        fill="#F0F3F9"
      />
    </svg>
  );
}
